module.exports = __webpack_public_path__ + "static/media/suv.03351ec4.svg";